import sizes from '../../../theme/foundations/sizes'
import {pxToRem} from '../../../utills/pxToRem'

export const formStyles = {
    label: {
        marginTop: pxToRem(20),
        marginBottom: pxToRem(5),
        fontSize: pxToRem(14),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        color: 'black',

        [`@media (min-width: ${sizes.container.md})`]: {
            marginTop: pxToRem(25),
            marginBottom: pxToRem(10),
            fontSize: pxToRem(16)
        }
    },
    input: {
        fontSize: pxToRem(16),
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        color: 'black'
    },
    span: {
        textTransform: 'none'
    }
}
